import MakeAcl from './makeAcl';

const acl = new MakeAcl();

export default acl;
